export const DEFAULT_CANDLE_STICK_COLORS_RGB = {
  positive: 'rgb(0, 159, 66)',
  negative: 'rgb(246, 71, 93)'
};

export const DEFAULT_CANDLE_STICK_COLORS_HEX = {
  positive: '#009f42',
  negative: '#f6475d'
};
